import { render, staticRenderFns } from "./ContactGroupingToggle.vue?vue&type=template&id=5210f944"
import script from "./ContactGroupingToggle.vue?vue&type=script&lang=js"
export * from "./ContactGroupingToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports